<ng-container *transloco="let t">
<div class="d-flex justify-content-center align-items-center info-tag px-12"
     [style.color]="amountStatus === AmountStatus.NOT_PAID ? 'var(--orange-500)' :
                    amountStatus === AmountStatus.UNDERPAID ? 'var(--blue-500)' :
                    amountStatus === AmountStatus.EXACT ? 'var(--green-800)' :
                    amountStatus === AmountStatus.EXPIRED ? 'var(--slate-400)' :
                    'var(--error-700)'"
     [style.background-color]="amountStatus === AmountStatus.NOT_PAID ? 'var(--orange-100)' :
                    amountStatus === AmountStatus.UNDERPAID ? 'var(--blue-100)' :
                    amountStatus === AmountStatus.EXACT ? 'var(--green-100)' :
                    amountStatus === AmountStatus.EXPIRED ? 'var(--teal-100)' :
                    'var(--error-50)'">
    <p>{{ t('my.tracey.order.state.' + amountStatus) | uppercase}}</p>
</div>
</ng-container>